import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmitterService } from '@service/emitter/emitter.service';
import { FactureCoproprietaireService } from '@service/syndic/facture-coproprietaire.service';
import { SyndicService } from '@service/syndic/syndic.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-facture-coproprietaire-add',
  templateUrl: './facture-coproprietaire-add.component.html',
  styleUrls: ['./facture-coproprietaire-add.component.scss']
})
export class FactureCoproprietaireAddComponent implements OnInit {
  form: FormGroup;
  submit: boolean = false;
  edit: boolean = false;
  facture: any;
  title: string = '';

  types = [
    { label: 'Débit', value: 'DEBIT' },
    { label: 'Crédit', value: 'CREDIT' }
  ];

  statuts = [
    { label: 'Brouillon', value: 'BROUILLON' },
    { label: 'Émise', value: 'EMISE' },
    { label: 'Payé partiellement', value: 'PAYE_PARTIELLEMENT' },
    { label: 'Payé', value: 'PAYE' },
    { label: 'Annulé', value: 'ANNULE' }
  ];

  categories = [
    { label: 'Appel de fonds', value: 'APPEL_FONDS' },
    { label: 'Pénalité', value: 'PENALITE' },
    { label: 'Travaux', value: 'TRAVAUX' },
    { label: 'Autre', value: 'AUTRE' }
  ];

  constructor(
    public toastr: ToastrService,
    public modal: NgbActiveModal,
    private formBuild: FormBuilder,
    private emitter: EmitterService,
    private factureService: FactureCoproprietaireService,
    private syndicService: SyndicService
  ) {
    this.edit = this.factureService.edit;
    this.facture = this.factureService.getFactureCoproprietaire();
    const lib = this.facture ? this.facture.libelle : '';
    this.title = (!this.edit) ? 'Ajouter une facture' : 'Modifier la facture ' + lib;
  }

  ngOnInit(): void {
    this.createForm();
    if (this.edit && this.facture) { this.setFormValue(); }
  }

  createForm(): void {
    this.form = this.formBuild.group({
      uuid: [null],
      type: ['DEBIT', [Validators.required]],
      libelle: [null, [Validators.required]],
      description: [null],
      montantTotal: [0, [Validators.required]],
      montantPaye: [0],
      statut: ['BROUILLON'],
      dateEmission: [null],
      dateEcheance: [null],
      categorie: [null],
      ownerCo: [null],
      fundsApeal: [null],
      trustee: [this.syndicService.getSyndic()?.uuid, [Validators.required]]
    });
  }

  setFormValue(): void {
    this.form.patchValue({
      uuid: this.facture.uuid,
      type: this.facture.type,
      libelle: this.facture.libelle,
      description: this.facture.description,
      montantTotal: this.facture.montantTotal,
      montantPaye: this.facture.montantPaye,
      statut: this.facture.statut,
      dateEmission: this.facture.dateEmission,
      dateEcheance: this.facture.dateEcheance,
      categorie: this.facture.categorie,
      ownerCo: this.facture.ownerCo?.uuid,
      fundsApeal: this.facture.fundsApeal?.uuid,
      trustee: this.facture.trustee?.uuid
    });
  }

  onSubmit(): void {
    this.submit = true;
    if (this.form.valid) {
      const data = this.form.getRawValue();
      this.factureService.add(data).subscribe(
        (res: any) => {
          if (res?.status === 'success') {
            this.modal.close('ferme');
            if (this.edit) {
              this.emitter.event.emit({ action: 'FACTURE_COPRO_UPDATED', payload: res?.data });
            } else {
              this.emitter.event.emit({ action: 'FACTURE_COPRO_ADD', payload: res?.data });
            }
            Swal.fire({ icon: 'success', title: 'Succès', text: res?.message });
          }
        },
        (error: any) => {
          const msg = error?.error?.message || 'Une erreur est survenue';
          Swal.fire({ icon: 'error', title: 'Erreur', text: msg });
        }
      );
    }
  }

  onClose(): void { this.modal.close('ferme'); }
  get f() { return this.form.controls; }
}
